import { render, staticRenderFns } from "./CerfaList.vue?vue&type=template&id=52406484"
import script from "./CerfaList.vue?vue&type=script&lang=js"
export * from "./CerfaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports